interface ITracker {
  [key: string]: (payload: any) => any;
}

let trackers = {} as ITracker;

// track mutation payloads, prefixed by module name
const trackMutations = (moduleName: string) => (
  options: {
    [key: string]: () => any,
  },
) => {
  const namedOptions = {} as {
    [key: string]: () => any,
  };
  for (const key in options) {
    const fullname = `${moduleName}/${key}`;
    namedOptions[fullname] = options[key];
  }
  trackers = {
    ...trackers,
    ...namedOptions,
  };
};

export default (callback: any) => (
  (store: any) => (
    store.subscribe((mutation: any) => {
      const { payload: data, type } = mutation;

      // track mutation if registered
      // and run callback with parsed payload
      if (trackers[type]) {
        const payload = trackers[type](data);
        callback(store, type, payload);
      }
    })
  )
);

export {
  trackMutations,
};
